import React, { useEffect } from 'react';
import { BonusSection } from './components/BonusSection';
import { ClosingSection } from './components/ClosingSection';
import { FAQ } from './components/FAQ';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Hero } from './components/Hero';
import { LookInsideCarousel } from './components/LookInsideCarousel';
import { MetaPixel } from './components/MetaPixel';
import { ModulesSection } from './components/ModulesSection';
import { PricingSection } from './components/PricingSection';
import { ProblemSection } from './components/ProblemSection';
import { PurchaseNotification } from './components/PurchaseNotification';
import { SummaryTable } from './components/SummaryTable';
import { SystemSection } from './components/SystemSection';
import { UrgencySection } from './components/UrgencySection';
import { productShortName } from './data/offer';
const pageDescription = 'Everything you need to teach DNA, heredity and genetics in your classroom. 6 visual teaching volumes, 5 exclusive bonuses and instant access.';
export function App() {
  useEffect(() => {
    document.title = productShortName;
    const setMeta = (attr: 'name' | 'property', key: string, content: string) => {
      let tag = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute(attr, key);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content);
    };
    setMeta('name', 'description', pageDescription);
    setMeta('property', 'og:title', productShortName);
    setMeta('property', 'og:description', pageDescription);
  }, []);
  return <div className="min-h-screen w-full overflow-hidden bg-background font-sans text-muted antialiased" data-id="element-0" data-mp="nw2c461hdqr3">
      <MetaPixel data-id="element-1" data-mp="stuclog6yl6w" />
      <main data-id="element-2" data-mp="stc7e2bjwwmu">
        <Hero data-id="element-3" data-mp="st2k4mhw53ku" />
        <LookInsideCarousel data-id="element-4" data-mp="swqbpg3rzfwx" />
        <ProblemSection data-id="element-5" data-mp="3686fj9n0kvj" />
        <SystemSection data-id="element-6" data-mp="35gmj5pekbl3" />
        <ModulesSection data-id="element-7" data-mp="34nabp7octvk" />
        <BonusSection data-id="element-8" data-mp="38b6kw4i7udz" />
        <UrgencySection data-id="element-9" data-mp="3udavo55x0h34" />
        <PricingSection data-id="element-10" data-mp="3ubriwojgwo63" />
        <GuaranteeSection data-id="element-11" data-mp="3ucjehzd2elwd" />
        <FAQ data-id="element-12" data-mp="d4nvlgp3tk2e" />
        <ClosingSection data-id="element-13" data-mp="d57g95652mk4" />
        <SummaryTable data-id="element-14" data-mp="d3mil6oj2ni1" />
        <FinalCta data-id="element-15" data-mp="d3wcv6glvgtj" />
      </main>
      <Footer data-id="element-16" data-mp="85l12q6r2w8o" />
      <PurchaseNotification data-id="element-17" data-mp="851lhg4kojxt" />
    </div>;
}